// extracted by mini-css-extract-plugin
export default {"parent":"styles_parent__Vc6Hy","customBox":"styles_customBox__S74tB","contentBox":"styles_contentBox__4RxgA","link":"styles_link__vE2Gl","headingBox":"styles_headingBox__FISFZ"};